/**
 * Lightweight analytics stub. Events currently console.log'd with a prefix.
 * Phase 4 will swap this to POST /api/analytics/track or a third-party service.
 */
const LOG_PREFIX = '[analytics]';

export const track = (event, properties = {}) => {
  try {
    // eslint-disable-next-line no-console
    console.info(LOG_PREFIX, event, properties);
    // Keep a session buffer for easy debug access in dev tools
    if (typeof window !== 'undefined') {
      window.__ssAnalytics = window.__ssAnalytics || [];
      window.__ssAnalytics.push({ event, properties, ts: Date.now() });
      if (window.__ssAnalytics.length > 200) window.__ssAnalytics.shift();
    }
  } catch {
    /* swallow */
  }
};

export const EVENTS = {
  REPORT_VIEW: 'report_view',
  UPGRADE_CLICK: 'upgrade_button_click',
  PAYMENT_SUCCESS: 'payment_success',
  PAYMENT_FAILURE: 'payment_failure',
  PDF_DOWNLOAD: 'pdf_download',
  EMAIL_PDF_SEND: 'email_pdf_send',
};
